// Material Dashboard 2 React components

import { Card, CardHeader, Grid, Icon, IconButton, TextField } from "@mui/material";
// Overview page components
import DashboardLayout from "~/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "~/examples/Navbars/DashboardNavbar";

import { App } from "antd";
// Material Dashboard 2 React components
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMutation } from "@tanstack/react-query";
import {
  Button,
  Collapse,
  DatePicker,
  Input,
  Modal,
  Pagination,
  Result,
  Segmented,
  Spin,
  Tooltip,
  Typography,
  theme,
} from "antd";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { roles } from "~/config";
import useAuthorization from "~/hooks/useAuthorization";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import reportsBarChartData from 'layouts/dashboard/data/reportsBarChartData';
import { ContainerOutlined } from "@ant-design/icons";
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined';
import {
  BarChartOutlined,
  EditNoteOutlined,
  StackedLineChartOutlined,
} from "@mui/icons-material";
import { Typography as AntTypography, Space } from "antd";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "~/App.css";
import MDBox from "~/components/MDBox";
import MDButton from "~/components/MDButton";
import MDTypography from "~/components/MDTypography";
import { dateTimeFormat } from "~/config";
import ReportsBarChart from "~/examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "~/examples/Charts/LineCharts/ReportsLineChart";
import usePagination from "~/hooks/usePagination";
import dashboardServices from "~/services/dashboard.services";
import { setClickedCardIndex } from "~/store/slices/utilities";
import GoogleAutocomplete from "~/utils/components/GoogleAutocomplete";
import {
  fieldsQualitative,
  fieldsQuantitative,
  filterFields,
  getQualitativeData,
  getQuantitativeData,
} from "./helper";
import { useUpdatePlantLocation } from "~/queries/plantMasterQuery";
import { getGeoLocations } from "~/queries/locationMasterQuery";
import MyLocationMap from "~/components/MyLocationMap";

const { Text, Link, Title } = AntTypography;
const dateFormat = "DD-MM-YYYY";

const Plants = () => {
  const params = useParams();
  const childRef = useRef();
  const formRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clickedCardIndex = useSelector((store) => store.utils?.clickedCards);

  const [expandIconPosition, setExpandIconPosition] = useState("start");
  const [items, setItems] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [latitude, setLatitude] = useState();
  const [altitude, setAltitude] = useState(null);
  const [longitude, setLongitude] = useState();
  const [address, setAddress] = useState();

  const [payload, setPayload] = useState({
    code: "",
    minDate: "",
    maxDate: "",
  });
  const [reportsBarChartData, setReportsBarChartData] = useState({});
  const [dates, setDates] = useState(null);
  const [chartType, setChartType] = useState("line");
  const [value, setValue] = useState("");
  const { token } = theme.useToken();
  const updatePlantLocation = useUpdatePlantLocation();
  const geoLocation = getGeoLocations();
  const { message: antMessage } = App.useApp();
  const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
  const { userHasRequiredRole } = useAuthorization([roles.ADMIN]);

  const panelStyle = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
  };

  const fetchLocationName = useCallback(async (latitude, longitude) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`;
    const response = await fetch(url);
    const data = await response.json();
    if (data.status === "OK" && data.results.length > 0) {
      const locationName = data.results[0].formatted_address;
      return locationName;
    } else {
      throw new Error("No location found");
    }
  }, [GOOGLE_MAPS_API_KEY]);

  const handleLocationClick = async (event, item) => {
    event.stopPropagation();
    const { Latitude, Longitude, Location, BarCode_Auto_ID } = item;
    setLatitude(Latitude);
    setLongitude(Longitude);
    setSelectedItem(BarCode_Auto_ID);
    setModalVisible(true);
    if (Location) {
      setAddress(Location);
    } else {
      try {
        const locationName = await fetchLocationName(Latitude, Longitude);
        setAddress(locationName);
      } catch (error) {
        setAddress("");
        console.error("Error fetching location name:", error);
      }
    }
  };

  const genExtra = (item) => (
    <Space.Compact block>
      <Tooltip title="Location">
        <Button
          onClick={(event) => handleLocationClick(event, item)}
          icon={<AddLocationAltOutlinedIcon />}
        >
          Location
        </Button>
      </Tooltip>
      <Tooltip title="List">
        <Button
          onClick={(event) => {
            dispatch(
              setClickedCardIndex({
                route: "plants",
                index: item.BarCode_Serial_No,
              })
            );
            // If you don't want click extra trigger collapse, you can prevent this:
            event.stopPropagation();
            navigate(
              `/dashboard/location/plots/plantation/plant-survey/${item.BarCode_Serial_No}`,
              { state: { name: item.BarCode_Serial_No } }
            );
          }}
          icon={<ContainerOutlined />}
        >
          List
        </Button>
      </Tooltip>
      <Tooltip title="Monitor">
        <Button
          onClick={(event) => {
            dispatch(
              setClickedCardIndex({
                route: "plants",
                index: item.BarCode_Serial_No,
              })
            );
            // If you don't want click extra trigger collapse, you can prevent this:
            event.stopPropagation();
            navigate(`/plant-monitoring/${item.BarCode_Serial_No}`, {
              state: { name: item.BarCode_Serial_No },
            });
            console.log("second icon");
          }}
          icon={<EditNoteOutlined />}
        >
          Monitor
        </Button>
      </Tooltip>
    </Space.Compact>
  );

  const {
    data: graphData,
    mutate,
    reset,
  } = useMutation({
    mutationKey: ["graphs", payload.code, payload.minDate, payload.maxDate],
    mutationFn: (payload) => dashboardServices.getPlantGraphData(payload),
    onSuccess: (data) => {
      console.log("ON Graph SUCCESS 🆘", data);

      const chartData = (data.data?.plant_monitoring_dtls || []).map(
        (item) => ({
          height:
            item.Plantation_Monitoring_Type === "Quantitative Monitoring"
              ? item.PlantGrowth_Height
              : NaN,
          typeValue:
            item.Plantation_Monitoring_Type === "Qualitative Monitoring"
              ? 10
              : NaN,
          date: moment(item.Created_Dt).format("DD-MM-YY hh:mm:ss A"),
          quantitative: getQuantitativeData(
            filterFields(item, fieldsQuantitative)
          ),
          qualitative: getQualitativeData(
            filterFields(item, fieldsQualitative)
          ),
          item: item,
        })
      );

      setReportsBarChartData({
        labels: chartData.map((item) => item.date).reverse(),
        datasets: [
          {
            label: "Quantitative",
            data: chartData.map((item) => item.height).reverse(),
            backgroundColor: "rgb(241, 246, 249)",
            quantitative: chartData.map((item) => item.quantitative).reverse(),
          },
          {
            label: "Qualitative",
            data: chartData.map((item) => item.typeValue).reverse(),
            backgroundColor: "rgb(33, 33, 33)",
            type: "line",
            qualitative: chartData.map((item) => item.qualitative).reverse(),
          },
        ],
      });
    },
  });

  const {
    data,
    isLoading,
    isSuccess,
    mutate: monitoringMutate,
  } = useMutation({
    mutationKey: [location.state?.Plantation_Auto_ID],
    mutationFn: (payloads) =>
      dashboardServices.getMonitoringPlantList(payloads),
    onSuccess: (data) => {
      console.log("ON SUCCESS 🆘", data);
      setItems(
        data?.data?.map((item) => ({
          key: item["plantationdtl.BarCode_Number"],
          label: (
            <Space
              direction="vertical"
              className={`${clickedCardIndex["plants"] === item.BarCode_Serial_No
                  ? "bounce"
                  : ""
                }`}
            >
              <Title level={5}>{item.BarCode_Serial_No}</Title>
              <Text strong>
                Total Monitoring Done : {item?.monitoringCount}
              </Text>
              {item.lastMonitoring?.Created_Dt && (
                <Text type="secondary">
                  Last Monitoring Date :{" "}
                  {moment(item.lastMonitoring?.Created_Dt).format(
                    dateTimeFormat
                  )}
                </Text>
              )}
            </Space>
          ),

          extra: genExtra(item),
          style: panelStyle,
          ...item,
        }))
      );
    },
  });
  const { currentPage, handlePageChange, pageSize } = usePagination(
    monitoringMutate,
    location.state?.Plantation_Auto_ID
  );

  const onCollapseChange = (item) => {
    console.log("ON CHANGE collapse", item);
    if (item) {
      mutate({
        ...payload,
        minDate: "",
        maxDate: "",
        code: item?.BarCode_Serial_No,
      });
      setPayload((prev) => ({ ...prev, code: item?.BarCode_Serial_No }));
    }
    setChartType("line");
    setValue("");
  };

  const disabledDate = (current, minDate, maxDate) => {
    if (!minDate || !maxDate) {
      return false;
    }

    const tooLate = current.isAfter(maxDate, "day");
    const tooEarly = current.isBefore(minDate, "day");
    return !!tooEarly || !!tooLate;
  };

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const handleDateRangeChange = (value) => {
    const fromDate = moment(value?.[0]["$d"]).format(dateFormat);
    const toDate = moment(value?.[1]["$d"]).format(dateFormat);
    setPayload((prev) => ({ ...prev, minDate: fromDate, maxDate: toDate }));
    setValue(value);
    mutate({ ...payload, minDate: fromDate, maxDate: toDate });
  };

  const handleModalOk = () => {
    setModalVisible(false);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  useEffect(() => {
    monitoringMutate({
      id: location.state?.Plantation_Auto_ID,
      currentPage,
      pageSize,
    });

    return () => {
      reset();
    };
  }, []);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude: sysLatitude, longitude: sysLongitude } = position.coords;
        setLatitude(sysLatitude);
        setLongitude(sysLongitude);

        // Fetch location name based on system latitude and longitude
        try {
          const locationName = await fetchLocationName(sysLatitude, sysLongitude);
          setAddress(locationName);
        } catch (error) {
          console.error("Error fetching location name:", error);
        }
      },
      (error) => {
        console.error("Error getting system location:", error);
      }
    );
  }, [latitude, longitude]);

  const initialValues = {
    Latitude: latitude ? latitude : "",
    Longitude: longitude ? longitude : "",
  };

  const validationSchema = Yup.object().shape({
    Latitude: Yup.string(),
    Longitude: Yup.string(),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {

    const datalocation = [+values.Latitude, +values.Longitude];

    try {
      const data = await geoLocation.mutateAsync(datalocation);
      if (data && data.results.length > 0) {
        setAltitude(data.results[0].elevation);
      } else {
        setAltitude(null);
      }
    } catch (error) {
      console.log(error)
    }

    try {
      const updateResponse = await updatePlantLocation.mutateAsync({
        ...values,
        params: selectedItem,
        Latitude: +values.Latitude,
        Longitude: +values.Longitude,
        Altitude_meter: altitude,
        Location: address
      });
      antMessage.success(updateResponse.data.message);
      setSubmitting(false);
      resetForm();
      childRef.current.clearInput();
      setModalVisible(false);
    } catch (error) {
      antMessage.error(error?.response?.data?.message);
    }
    // Handle the form submission here
  };

  function getGoogleAutocomplete(place) {
  if (place !== null) {
    const { description, geometry } = place;
    formRef.current.setFieldValue("Latitude", geometry.lat);
    formRef.current.setFieldValue("Longitude", geometry.lng);

    setLatitude(geometry.lat);
    setLongitude(geometry.lng);
    setAddress(description);
  }
}

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        sx={{
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <MDBox>
          <CardHeader
            action={
              <MDButton
                variant="contained"
                color="success"
                aria-label="navigation"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
              >
                Back
              </MDButton>
            }
            title={location.state?.plant_mstr.Plant_Local_Name}
            subheader={
              <Typography.Title level={5}>
                {location.state?.plant_mstr.Plant_Scientific_Name}
              </Typography.Title>
            }
          />
          {/* <MDTypography variant="h5">Create Plant</MDTypography> */}
        </MDBox>

        <MDBox p={2}>
          <Spin tip="Loading..." spinning={isLoading}>
            {items.length === 0 && isSuccess ? (
              <Result
                status="404"
                title="No Content"
              // subTitle="No Data to show"
              //   extra={
              //     <Button type="primary" onClick={() => navigate(-1)}>
              //       Back
              //     </Button>
              //   }
              />
            ) : null}
            <Grid container spacing={3}>
              <Grid item lg={12}>
                <Collapse
                  accordion={true}
                  // defaultActiveKey={['1']}
                  style={{ border: "none" }}
                  size="small"
                  onChange={(item) =>
                    onCollapseChange(items[parseInt(item[0])])
                  }
                  expandIconPosition={expandIconPosition}
                  items={items.map((item) => ({
                    ...item,
                    children: (
                      <>
                        <MDBox
                          mb={1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Space>
                            <Segmented
                              defaultValue={"line"}
                              options={[
                                {
                                  label: "Line Chart",
                                  value: "line",
                                  icon: <StackedLineChartOutlined />,
                                },
                                {
                                  label: "Bar Chart",
                                  value: "bar",
                                  icon: <BarChartOutlined />,
                                },
                              ]}
                              onChange={(value) => setChartType(value)}
                            />
                            <MDTypography
                              variant="button"
                              color="text"
                              lineHeight={1}
                              sx={{ mt: 0.15, mr: 0.5 }}
                            >
                              <Icon>calender</Icon>
                            </MDTypography>
                            <MDTypography
                              variant="button"
                              color="text"
                              fontWeight="light"
                            >
                              <DatePicker.RangePicker
                                defaultValue={[
                                  moment(item.minDate).format(dateFormat),
                                  moment(item.maxDate).format(dateFormat),
                                ]}
                                format={dateFormat}
                                value={value}
                                disabledDate={(current) =>
                                  disabledDate(
                                    current,
                                    item.minDate,
                                    item.maxDate
                                  )
                                }
                                onCalendarChange={(val) => {
                                  setDates(val);
                                }}
                                onOpenChange={onOpenChange}
                                onChange={handleDateRangeChange}
                              />
                            </MDTypography>
                          </Space>
                        </MDBox>
                        {chartType === "line" ? (
                          <ReportsLineChart
                            color="info"
                            // title="plant views"
                            // description="Monitored Plants Growth"
                            chart={reportsBarChartData}
                          />
                        ) : (
                          <ReportsBarChart
                            color="info"
                            // title="plant views"
                            // description="Monitored Plants Growth"
                            chart={reportsBarChartData}
                          />
                        )}
                      </>
                    ),
                  }))}
                />
              </Grid>
              <Grid item lg={12} justifyContent="center">
                <Pagination
                  showSizeChanger
                  defaultCurrent={currentPage}
                  total={data?.count ?? 10}
                  onChange={handlePageChange}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`
                  }
                />
              </Grid>
            </Grid>
          </Spin>
        </MDBox>
      </Card>
      <Modal
        title="Add Location Details"
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={[
          <Button key="back" onClick={handleModalCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              console.log(formRef.current)
              if (formRef.current) {
                formRef.current.submitForm(); // Use submitForm instead of handleSubmit
              }
            }}
          >
            Submit
          </Button>,
        ]}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          innerRef={formRef}
        >
          {({ handleChange, handleBlur, values, setFieldValue }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={6} xs={6}>
                  <MDBox p={2}>
                    {latitude && longitude ? (<MyLocationMap
                      coordinates={{
                        lat: latitude ? Number(latitude) : 0,
                        lng: longitude ? Number(longitude) : 0
                      }}
                      location={address ? address : "Location Name"}
                    />
                    ) : <Spin />}
                  </MDBox>
                </Grid>
                <Grid item xs={12}>
                  <GoogleAutocomplete
                    ref={childRef}
                    getPlaceOption={getGoogleAutocomplete}
                    locationValue={address ? address : ""}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    onBlur={handleBlur}
                    onChange={(e) => { setLatitude(e.target.value); handleChange(e) }}
                    value={values.Latitude}
                    id="latitude-basic"
                    label="Latitude"
                    name="Latitude"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    onBlur={handleBlur}
                    onChange={(e) => { setLongitude(e.target.value); handleChange(e) }}
                    value={values.Longitude}
                    id="longitude-basic"
                    label="Longitude"
                    name="Longitude"
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Modal>
    </DashboardLayout>
  );
};

export default Plants;
